import { VariableType } from 'json-to-graphql-query';

export const OfferAcceptVariables = { id: 'Int!', teamIds: '[Int!]!' };
export const OfferAcceptArgs = { id: new VariableType('id'), teamIds: new VariableType('teamIds') };
